import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['']

  connect() {
    this.checks = 0
    this.maxChecks = 45 // ~90s safety cap so a stuck pull never traps the user
    this.checkStatus()
  }

  checkStatus() {
    // Safety net: if we never get a final status, fall back to the dashboard so
    // the user can retry or fill the form manually.
    if (this.checks >= this.maxChecks) {
      window.location.href = '/kycs/sg/?myinfo_error=1'
      return
    }
    this.checks += 1

    // Make an AJAX request to fetch the status from the endpoint.
    fetch('/my-info/status/')
      .then((response) => response.json())
      .then((data) => {
        // On success, go to the KYC form to preview the retrieved data and submit;
        // on error, return to the dashboard so the user can retry or go manual.
        if (data.status === 'success') {
          window.location.href = '/kycs/sg/kyc/'
          return
        }
        if (data.status === 'error') {
          window.location.href = '/kycs/sg/?myinfo_error=1'
          return
        }

        // If not final, continue checking after a delay (e.g., every 2 seconds).
        setTimeout(() => {
          this.checkStatus()
        }, 2000) // Adjust the delay as needed.
      })
      .catch((error) => {
        // Handle any errors from the AJAX request here.
        console.error('Error fetching status:', error)
      })
  }
}
